/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PaymentPlan/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PaymentPlan({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Payors/Content/Payors/Payor/Content/Content/PaymentPlan"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtColorsGreen700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700'
        })
  return (<React.Fragment
>
<div
  data-testid="PaymentPlan.Vertical"
  data-view-path={viewPath}
 style={{'--g-1-9c73A': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-2-9c73A': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-3-9c73A': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-4-9c73A': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-5-9c73A': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="PaymentPlan.Vertical:1"
  data-view-path={viewPath}
 style={{'--g-1-9c73A': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Payment plan"
 weight="medium"
/>
<div
  data-testid="PaymentPlan.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-6-9c73A': dtColorsNeutral300}}
 className={`views-block ${styles.Horizontal}`}
/>
<div
  data-testid="PaymentPlan.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 weight="medium"
 text="$1250.00 paid"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="tiny"
 color={dtColorsNeutral500}
 text="10 months (62.5%)"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="$2000.00"
/>
</div>
</div>
<div
  data-testid="PaymentPlan.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Remaining to be paid"
 color={dtColorsNeutral500}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="$750.00"
 color={dtColorsGreen700}
/>
</div>
<div
  data-testid="PaymentPlan.Horizontal:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal3}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Remaining installment months"
 color={dtColorsNeutral500}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text={5}
 color={dtColorsGreen700}
/>
</div>
<div
  data-testid="PaymentPlan.Horizontal:4"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal4}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Downpayment"
 color={dtColorsNeutral500}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="$500.00"
/>
</div>
<div
  data-testid="PaymentPlan.Horizontal:5"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal5}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Installment amount"
 color={dtColorsNeutral500}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="$1500.00"
/>
</div>
<div
  data-testid="PaymentPlan.Horizontal:6"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal6}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Installment will be paid"
 color={dtColorsNeutral500}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Monthly"
/>
</div>
<div
  data-testid="PaymentPlan.Horizontal:7"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal7}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Installment paid on"
 color={dtColorsNeutral500}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="20th of every month"
/>
</div>
<div
  data-testid="PaymentPlan.Horizontal:8"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal8}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="First installment started on"
 color={dtColorsNeutral500}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Jan 20 2025"
/>
</div>
<div
  data-testid="PaymentPlan.Horizontal:9"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal9}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Autopay method"
 color={dtColorsNeutral500}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Card ***0927, expiry 05/28"
/>
</div>
<div
  data-testid="PaymentPlan.Vertical:2"
  data-view-path={viewPath}
 style={{'--g-1-9c73A': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical2}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Notes"
 color={dtColorsNeutral500}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 text="Patient wants to discuss with insurance company."
/>
</div>
</div>
{children}
</React.Fragment>)
}